module.exports = __webpack_public_path__ + "static/media/star-empty-light.a049b6c9.svg";